import { gql } from "apollo-boost";
import React from "react";
import { useCustomQuery } from "./useCustomQuery";
import { arrInvalid, getFullName, reducerFn } from "../helper";

const useTeamUserByRoles = (roles, fragment, skip) => {
  const q = React.useMemo(() => {
    return {
      skip,
      variables: {
        roles,
      },
      query: gql`
        query listUserTeamByRoles($roles: [String!]!) {
          listUserTeamByRoles(roles: $roles) {
            ${fragment}
          }
        }
      `,
    };
  }, [fragment, skip, JSON.stringify(roles)]);

  return useCustomQuery({
    queryOptions: q,
    path: "data.listUserTeamByRoles",
  });
};

const DEFAULT_FRAGMENT = "id user { id firstName lastName }";
export function useTeamUserFilter({
  value,
  skip,
  fragment = DEFAULT_FRAGMENT,
  roles,
}) {
  const [state, setState] = React.useReducer(reducerFn, {
    options: [],
    selectedOptions: [],
  });

  const { data, loading, error } = useTeamUserByRoles(roles, fragment, skip);
  const setDataRef = React.useRef(false);
  React.useEffect(() => {
    if (arrInvalid(data) || setDataRef.current) return;

    const fn = (item) => {
      const user = item?.user;
      if (!user) return;
      const label = getFullName(user);
      return { value: user?.id, label };
    };

    const options = data.map(fn).filter(Boolean);
    setState({ options });
    setDataRef.current = true;
  }, [data]);

  const optionsStr = JSON.stringify(state.options);
  React.useEffect(() => {
    const options = JSON.parse(optionsStr);
    if (arrInvalid(options) || arrInvalid(value)) return;

    const selectedOptions = options.filter(({ value: v }) => value.includes(v));
    setState({ selectedOptions });
  }, [optionsStr, value]);

  return React.useMemo(
    () => ({
      loading,
      error,
      options: state.options,
      selectedOptions: state.selectedOptions,
    }),
    [loading, error, state.options, state.selectedOptions],
  );
}
